import React, { useEffect } from 'react'

import { useHistory } from 'react-router'

import AuthLayouts from '../layouts/AuthLayouts'

import ScrollToTop from '../components/ScrollRestoration'
import { StyledVerify } from './PasswordVerification'

// icons
import checkCircle from '../assets/images/check-circle.svg'

const SuccessfulVacancyRequest = () => {
  const history = useHistory()

  useEffect(() => {
    // redirect to home page after 5 seconds
    setTimeout(() => {
      history.push('/')
    }, 5000)
  }, [])

  const handleRedirect = () => {
    history.push('/')
  }

  return (
    <AuthLayouts width="500px">
      <ScrollToTop />
      <StyledVerify>
        <img src={checkCircle} alt="mail" className="icon" />
        <h1>Vacancy Request Submitted</h1>
        <p>
          Thank you for submitting your vacancy request! Our team has received
          your details and will review them promptly. We’ll reach out to you
          once your request has been processed.
        </p>
        <p>
          If you&apos;re not redirected to the home page in 5 seconds, click
          <span onClick={handleRedirect}> here </span> to go there manually.
        </p>
      </StyledVerify>
    </AuthLayouts>
  )
}

export default SuccessfulVacancyRequest
